import React, { FC } from 'react';
import { TemplateWrapper } from 'src/templates';

import cx from 'classnames';
import Image from 'src/components/Image';
import { PartnerContactForm } from 'src/components/Forms';
import { Grid, Column } from 'src/components/Layout/Grid';

import { Locales, CmsThemes } from 'src/lib/constants';
import { dangerous_getStaticData } from 'src/lib/getStaticData';
import styles from './contact.module.scss';
import MainNavigationSpacer from 'src/components-v2/MainNavigationBar/MainNavigationSpacer';

interface Props {
  locale?: string;
}

const PartnerContactPage: FC<Props> = ({ locale = Locales.EN_US }) => {
  const { metaData, header, subheader, socialProofData, ctas } =
    dangerous_getStaticData({
      locale,
      filePath: 'partnerContact',
    });
  return (
    <TemplateWrapper {...metaData} locale={locale} cmsTheme={CmsThemes.WEB3}>
      <MainNavigationSpacer />
      <section
        className={cx(styles.background_page_wrapper, styles.section_container)}
      >
        <Grid>
          <h2 className={styles.section_header}>{header}</h2>
        </Grid>
        <Grid useThreadsGrid>
          <Column large={6}>
            <div className={styles.partner_contact_form_container}>
              <Grid
                containerClassName={styles.partner_contact_subheader_container}
              >
                <Column large={12}>
                  <p className={styles.section_subheader}>{subheader}</p>
                </Column>
              </Grid>
              <PartnerContactForm />
            </div>
          </Column>
          <Column large={6}>
            <div className={cx(styles.separator)}></div>
            <p
              dangerouslySetInnerHTML={{
                __html: socialProofData?.description,
              }}
            />
            <div className={styles.logoContainer}>
              {socialProofData.items.map((item, i) => {
                return (
                  <div
                    key={`item-${i}`}
                    className={cx(
                      styles.social_proof_logo,
                      styles.social_proof_logo__no_padding,
                    )}
                  >
                    <Image src={item.src} alt={item.alt} />
                  </div>
                );
              })}
            </div>

            <div className={cx(styles.separator)}></div>
            <p className={styles.description}>{ctas?.description}</p>
            {ctas?.links?.map((link) => {
              return <p dangerouslySetInnerHTML={{ __html: link }} />;
            })}
          </Column>
        </Grid>
      </section>
    </TemplateWrapper>
  );
};
PartnerContactPage.displayName = 'PartnerContactPage';
export default PartnerContactPage;
